import styled from 'styled-components';
import { key } from 'styled-theme';
import { prop } from 'styled-tools';

import InputContainer from './InputContainer';
import Input from './Input';

export default styled.div`
  width: ${prop('width', '100%')};
  margin: 0 auto;

  ~ button {
    display: block;
    width: 100%;
    margin-top: 16px;
  }

  > ${InputContainer} {
    display: block;
    width: 100%;

    &:first-child > ${Input} {
      border-top-right-radius: ${key('sizes.borderRadius')};
      border-top-left-radius: ${key('sizes.borderRadius')};
    }

    &:last-child > ${Input} {
      border-bottom-right-radius: ${key('sizes.borderRadius')};
      border-bottom-left-radius: ${key('sizes.borderRadius')};
    }

    > ${Input} {
      border-radius: 0;
      margin: 0;
    }

    + ${InputContainer} > ${Input} {
      border-top: 0;
    }
  }
`;
